import React, { useCallback, useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import {
  collection,
  getFirestore,
  limit,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { useParams } from "react-router-dom";
import { ScrollShadow } from "@nextui-org/react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Divider,
  Link,
  Image,
  Badge,
  cn,
} from "@nextui-org/react";
import he from "he";
import QRCode from "qrcode.react";
import { format } from "date-fns";

type RoomParams = {
  id: string;
};

type ata = {
  id?: string;
  textoAta: string;
  ataTexto: string;
  idPalta: string;
  numero: string;
  votado: boolean;
  leituraVis: boolean;
  downloadURL: string;
  tituloAtaExpediente: string;
  solicitacaoVotacao: boolean;
};

type infoSolicitarPresenca = {
  sessao: {
    id: string;
    dataSessao: string;
    legislatura: string;
    periodo: string;
    sessao: string;
    statusConfigSessao: number;
    statusSessao: string;
    tipoSessao: string;
  };
};

export function LeituraAta({ sessao }: infoSolicitarPresenca) {
  const params = useParams<RoomParams>();
  const roomId = params.id;
  const parser = new DOMParser();
  const scrollRef = useRef(null);

  const [atasVis, setAtasVis] = useState({} as ata);
  const [time, setTime] = useState(new Date());

  const [presencaParlamentares, setPresencaParlamentares] = useState([]);

  const stripHtml = (html: string) => {
    const decodedHtml = he.decode(html); // Decodifica entidades HTML
    const doc = new DOMParser().parseFromString(decodedHtml, "text/html");
    return doc.body.textContent || "";
  };

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "presencaParlamentares"
    );

    onSnapshot(ordersRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          id: doc.id,
          ...data,
        };
      });

      setPresencaParlamentares(parsedData as any);
    });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const startAutoScroll = useCallback(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    //@ts-ignore
    const scrollHeight = scrollContainer.scrollHeight;
    //@ts-ignore
    const clientHeight = scrollContainer.clientHeight;

    const scroll = () => {
      //@ts-ignore
      if (scrollContainer.scrollTop + clientHeight >= scrollHeight) {
        //@ts-ignore
        scrollContainer.scrollTop = 0;
      } else {
        //@ts-ignore
        scrollContainer.scrollBy({ top: 1, behavior: "smooth" });
      }
    };

    const intervalId = setInterval(scroll, 100);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      startAutoScroll();
    }
    //@ts-ignore
  }, [startAutoScroll, atasVis]);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "atas"
    );
    const queryRef = query(
      ordersRef,
      where("leituraVis", "==", true),
      limit(1)
    );

    onSnapshot(queryRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return { id: doc.id, ataTexto: stripHtml(data.textoAta), ...data };
      });

      //@ts-ignore
      setAtasVis(parsedData[0]);
      startAutoScroll();
    });
  }, []);

  return (
    <div className="min-h-screen flex flex-col justify-between p-0 bg-gray-900">
      <div>
        <Card className="min-w-[100%] h-22 items-center bg-gray-900 p-0 ">
          <CardHeader className="flex flex-col items-center">
            <h1 className="text-5xl font-extrabold  uppercase text-gray-50">
              Câmara Municipal de Bela Cruz
            </h1>
            <Divider className="bg-amber-300 my-2 h-[8px] " />
          </CardHeader>
        </Card>
      </div>

      <div className="px-9 -mt-6">
        {
          //@ts-ignore
          atasVis?.ataTexto != undefined && (
            <div className={"bg-gray-900 "}>
              <ScrollShadow
                hideScrollBar
                ref={scrollRef}
                style={{
                  overflowY: "auto",
                  maxHeight: "36rem",
                  height: "33rem",
                }}
              >
                <p className="text-3xl text-justify font-GeneralSansMedium text-white mb-3">
                  {atasVis.ataTexto}
                </p>
              </ScrollShadow>
            </div>
          )
        }
      </div>

      <div>
        <Divider className="bg-gray-700 h-[18px]" />

        <div className="grid h-full w-full grid-cols-3 ">
          <div className="flex flex-col h-full">
            <div className="p-1 border-1 border-gray-700 h-full text-5xl text-center font-bold text-gray-50">
              {format(new Date(), "HH:mm:ss")}
            </div>
            <div className="p-1 border-1 border-gray-700 h-full text-2xl text-center font-normal text-gray-50">
              {format(new Date(), "dd/MM/yyyy")}
            </div>
          </div>

          <div className="flex h-full w-full flex-row justify-between">
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                SIM
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full w-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                NÃO
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                ABST
              </div>
            </div>
          </div>

          <div className=" h-full w-full flex flex-col justify-between">
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-white">
              <span className="text-2xl font-semibold ">PARLAMENTARES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length}
              </span>
            </div>
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-red-500">
              <span className="text-2xl font-semibold ">AUSENTES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length -
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length}
              </span>
            </div>
            <div className="p-1 h-full w-full flex flex-row justify-between px-16 border-1 border-slate-600 text-2xl text-center font-normal text-blue-400">
              <span className="text-2xl font-bold ">PRESENTES</span>
              <span className="text-2xl font-bold ">
                {
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
